import { useState, useEffect } from 'react';
import * as db from '../db';
import { usePriceOverrides } from '../context/PriceOverridesContext';

// React hook to access database functions.
// `isLoading` stays true until BOTH the local data is initialized AND the
// remote price overrides have loaded — so consumers that gate data-loading
// useEffects on `isLoading` see overrides applied on first render.
const useDatabase = () => {
  const [dbReady, setDbReady] = useState(false);
  const { loading: overridesLoading } = usePriceOverrides();

  useEffect(() => {
    try {
      const categories = db.getMeatCategories();
      if (categories) {
        setDbReady(true);
      }
    } catch (error) {
      console.error('Database error:', error);
      setDbReady(true);
    }
  }, []);

  return {
    isLoading: !dbReady || overridesLoading,
    ...db,
  };
};

export default useDatabase;
